import { render, staticRenderFns } from "./BuyPayment.vue?vue&type=template&id=134d000e&scoped=true&"
import script from "./BuyPayment.vue?vue&type=script&lang=js&"
export * from "./BuyPayment.vue?vue&type=script&lang=js&"
import style0 from "./BuyPayment.vue?vue&type=style&index=0&id=134d000e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d000e",
  null
  
)

export default component.exports